module.exports = __webpack_public_path__ + "static/img/广州银行.55555b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/广州银行.png
// module id = CWyc
// module chunks = 18